import Button from '@components/Button';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useSignIn from '../../hooks/useSignIn';

function SignInFooter() {
    const { t } = useTranslation('signIn');
    const { login, isVerified } = useSignIn();
    return (
        <Container>
            <Button onClick={login}
                fullWidth
                disabled={!isVerified}>
                {t('phone.login')}
            </Button>
        </Container>
    );
}

const Container = styled.div`
    padding: 0 20px 28px;
    width: 100%;
`;

export default SignInFooter;
